const COLORS: Record<string, string> = {
  pending: "bg-gray-100 text-gray-600 dark:bg-gray-800 dark:text-gray-300",
  generating: "bg-blue-100 text-blue-700 dark:bg-blue-900 dark:text-blue-200",
  queued: "bg-blue-100 text-blue-700 dark:bg-blue-900 dark:text-blue-200",
  claimed: "bg-blue-100 text-blue-700 dark:bg-blue-900 dark:text-blue-200",
  running: "bg-blue-100 text-blue-700 dark:bg-blue-900 dark:text-blue-200",
  review: "bg-amber-100 text-amber-800 dark:bg-amber-900 dark:text-amber-200",
  accepted: "bg-green-100 text-green-700 dark:bg-green-900 dark:text-green-200",
  succeeded: "bg-green-100 text-green-700 dark:bg-green-900 dark:text-green-200",
  rejected: "bg-red-100 text-red-700 dark:bg-red-900 dark:text-red-200",
  failed: "bg-red-100 text-red-700 dark:bg-red-900 dark:text-red-200",
  cancelled: "bg-red-100 text-red-700 dark:bg-red-900 dark:text-red-200",
};

export function StatusChip({ status, label }: { status: string; label: string }) {
  return <span className={`rounded px-1.5 py-0.5 text-xs ${COLORS[status] ?? COLORS.pending}`}>{label}</span>;
}
